import {FLOW_TRIGGER_IDS} from "../consts/flowTriggerIds";

export const getPlaceholdersByTriggerIdAndConsent = (consent: boolean, flowTriggerId?: number) => {
    const base = ['name', 'shop'];
    if(flowTriggerId === FLOW_TRIGGER_IDS.ABANDONED_CHECKOUT_IDENTIFICATION) { //recovery
        return [ ...base, 'cart', 'price', 'coupon code'];
    } else if(flowTriggerId === FLOW_TRIGGER_IDS.ON_PURCHASE && consent) { // purchase completed marketing
        return [ ...base, 'order ID'];
    } else if(flowTriggerId === FLOW_TRIGGER_IDS.ON_PURCHASE && !consent) { // purchase completed utility
        return [ ...base, 'order ID'];
    } else if(flowTriggerId === FLOW_TRIGGER_IDS.ON_NEW_SIGNUP && consent) { // Customer registered marketing
        return [ ...base];
    } else if(flowTriggerId === FLOW_TRIGGER_IDS.ON_NEW_SIGNUP && !consent) { // Customer registered utility
        return [ ...base];
    } else if(flowTriggerId === FLOW_TRIGGER_IDS.ON_SHIPPING_ACKNOWLEDGED) { //shipment acknowledged utility
        return [ ...base, 'order ID', 'tracking URL', 'tracking ID'];
    }

    return base;
}